module.exports = __webpack_public_path__ + "static/media/image.70634ce1.png";